import storage from 'redux-persist/lib/storage'

// https://blog.logrocket.com/persist-state-redux-persist-redux-toolkit-react/
export const persistConfig = {
  key: 'lampsideRoot',
  storage,
  whitelist: ['auth'],
}

